import { Component, AfterViewInit, OnDestroy, AfterViewChecked, HostListener, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { isQuoteAssitantAlive } from './@core/modules';
import * as AOS from 'aos';
import * as $ from 'jquery';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';


declare var $: any;

@Component({
  selector: 'vc-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  public loaded = false;
  previousUrl: string;
  el: any;
  // spinnerShowing: boolean = true;
  constructor(
    private _router: Router,
    private _scrollToService: ScrollToService,
    private renderer: Renderer2
  ) {


    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);

      }

      if (event instanceof NavigationStart) {
        let currentUrlSlug = event.url.slice(1);
        if (currentUrlSlug != "van-insurance/payments") {
          this.renderer.removeClass(document.body, "blueGradBg");
        }
        this.previousUrl = currentUrlSlug;
      }
    });

  }


  @HostListener("window:load")
  doSomething() {
    $('.vc-loading').addClass('loaded');

    if (isQuoteAssitantAlive()) {
      AOS.init({
        once: true,
        offset: -200
      });
    }

    //this.savePage1();
  }




  ngOnInit() {
    //
    // this.routerSubscription = this._router.events.subscribe((event: NavigationEnd) => {
    //     if(event instanceof NavigationEnd) {
    //       window.scrollTo(0, 0);
    //     }
    //   })
  }


  ngOnDestroy() {
    // this.routerSubscription.unsubscribe();
  }


  ngAfterViewInit() {
  }

  ngAfterViewChecked() {
    if (!isQuoteAssitantAlive()) {
      AOS.init({
        disable: true
      });
    }
  }

}
